/**
 * Helper just usefull to centralize data for Back-office request
 */
export enum ScheduleHelper {
  DAILY = 'day',
  WEEKLY = 'week',
  MONTHLY = 'month',
  MONTHLYJ4 = 'monthJ4',
  QUATERLY = 'quarter',
}
